import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PiImageThin } from 'react-icons/pi';
import { app } from '../../actions';
import s from './style.css';
const PreviewImageFile = ({ file, uri, downloading, cacheVaultFile }) => {
    const [retried, setRetried] = useState(false);
    useEffect(() => {
        if (!uri) {
            cacheVaultFile({ file, isPreview: true });
        }
    }, []);
    const handleError = () => {
        if (retried)
            return;
        setRetried(true);
        cacheVaultFile({ file, isPreview: true });
    };
    return uri && !downloading ? (React.createElement("img", { src: uri, className: s.imageFile, onError: handleError })) : (React.createElement(PiImageThin, { size: 80, className: s.placeholder }));
};
const mapStateToProps = (state, ownProps) => ({
    uri: state.vaultCache[ownProps.file.previewUriKey] ? state.vaultCache[ownProps.file.previewUriKey].uri : null,
    downloading: state.download[ownProps.file.previewUriKey],
});
const connector = connect(mapStateToProps, { ...app });
export default connector(PreviewImageFile);
